import { useContext } from "react";
import { TriaUserContext } from "./tria-user-provider.context";

// This hook can be used to access the user info.

export const useTriaUser = () => useContext(TriaUserContext);
